import React, { createContext } from "react";

import "./HomePage.css";

import Header from "../components/Header/Header";
import Boards from "../components/Boards/Boards";
import About from "../components/About/About";
import Advants from "../components/Advants/Advants";
import Businesses from "../components/Businesses/Businesses";
// import Goals from "../components/Goals/Goals";
import Tetrad from "../components/Tetrad/Tetrad";
import Footer from "../components/Footer/Footer";

// export const MenuContext = createContext({
//     isMenuOpen: true,
//     toggleMenu: () => {},
// });

function Home() {
  return (
    <div className="wrap">
      <Header />
          <div className="body">
              <Boards />
              <About />
              <Advants />
              <Businesses />
              {/* <Goals /> */}
              <Tetrad />
          </div>
      <Footer />
    </div>
  );
}

export default Home;
